import React, { useState } from 'react';
import { NumericFormat } from 'react-number-format';
import { SimpleAlert } from '../../../../rbts/helpers';
import { useActualizarPrecio } from '../hooks/DonationsHook';

type Props = {
  row: any;
};

const EditarCelda: React.FC<Props> = ({ row }) => {
  const [value, setValue] = useState<number>(row.costo_sugerido);
  const [hasFocus, setHasFocus] = useState<boolean>(false);
  const { actualizarPrecio, loading } = useActualizarPrecio();

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      //   SimpleAlert('Se actualizó el precio exitosamente.', 3000, 'success');
      actualizarPrecio(row.id, value);
    }
  };

  return (
    <div className="fs-012 font-weight-normal text-muted">
      <NumericFormat
        value={value}
        placeholder="$0.00"
        className="form-control"
        thousandSeparator={true}
        prefix="$"
        decimalScale={2}
        fixedDecimalScale={true}
        allowNegative={false}
        allowLeadingZeros={false}
        onValueChange={(values) => setValue(values.floatValue ?? 0)}
        onKeyDown={handleKeyDown}
        onFocus={() => setHasFocus(true)}
        onBlur={() => setHasFocus(false)}
      />
      {hasFocus && <small>Presione enter para guardar</small>}
    </div>
  );
};

export { EditarCelda };
